// Objectifs de macronutriments — suggestion ajustable.
// Mode auto : lipides = fatPct % du seuil, protéines = objectif protéique,
// glucides = calories restantes. Mode manuel : grammes fixés.
import { ATWATER } from './energy';
import { round } from './statistics';

export interface MacroTargets {
  proteinG: number;
  carbG: number;
  fatG: number;
  proteinPct: number; // % des calories
  carbPct: number;
  fatPct: number;
}

export function deriveMacroTargets(
  calorieThreshold: number,
  proteinTargetG: number,
  fatPct: number,
): MacroTargets {
  const proteinKcal = proteinTargetG * ATWATER.protein;
  const fatKcal = (calorieThreshold * fatPct) / 100;
  // Glucides = reste (borné à 0 si prot+lip dépassent le seuil).
  const carbKcal = Math.max(0, calorieThreshold - proteinKcal - fatKcal);
  return normalize(proteinKcal, carbKcal, fatKcal, calorieThreshold);
}

export function macroTargetsFromGrams(proteinG: number, carbG: number, fatG: number): MacroTargets {
  const proteinKcal = proteinG * ATWATER.protein;
  const carbKcal = carbG * ATWATER.carbs;
  const fatKcal = fatG * ATWATER.fat;
  const total = proteinKcal + carbKcal + fatKcal;
  return normalize(proteinKcal, carbKcal, fatKcal, total);
}

// Convertit des kcal par macro en grammes + pourcentages (base = `total`).
function normalize(
  proteinKcal: number,
  carbKcal: number,
  fatKcal: number,
  total: number,
): MacroTargets {
  const pct = (kcal: number) => (total > 0 ? round((kcal / total) * 100, 1) : 0);
  return {
    proteinG: round(proteinKcal / ATWATER.protein),
    carbG: round(carbKcal / ATWATER.carbs),
    fatG: round(fatKcal / ATWATER.fat),
    proteinPct: pct(proteinKcal),
    carbPct: pct(carbKcal),
    fatPct: pct(fatKcal),
  };
}
